module.exports = __webpack_public_path__ + "img/husky.6543558d.jpg";